import { UserActionTypes } from "./user.type";

const INITIAL_STATE = {
  currentUser: false,
};

//Here if currentState is Null ..then the INITIAL_STATE will be assigned to current State

const userReducer = (currentState = INITIAL_STATE, action) => {
  switch (action.type) {
    case UserActionTypes.AUTH_USER:
      return {
        ...currentState,
        currentUser: !currentState.currentUser,
      };
    case UserActionTypes.DESTORY_SESSION:
      return {
        ...currentState,
        currentUser: !currentState.currentUser,
      };
    default:
      return currentState;
  }
};

export default userReducer;
